module.exports = __webpack_public_path__ + "img/woo-commerce.a1453bfa.png";